module.exports = __webpack_public_path__ + "static/media/HowDoesThisHelpTheEnvironment.9df1e30d.png";